module.exports = ".form-error {\n  color: red;\n  font-size: 11px;\n  list-style: none;\n  padding-left: 0;\n}\n.form-error li {\n  display: block;\n  margin: 5px 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/formError/formError.component.less
// module id = ./src/app/components/common/formError/formError.component.less
// module chunks = main